/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsPreview,
    SharedserviceMelcoModelsPreviewFromJSON,
    SharedserviceMelcoModelsPreviewFromJSONTyped,
    SharedserviceMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet
 */
export interface SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsPreview>}
     * @memberof SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet
     */
    previews?: Array<SharedserviceMelcoModelsPreview> | null;
}

export function SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetFromJSON(json: any): SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet {
    return SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(SharedserviceMelcoModelsPreviewFromJSON)),
    };
}

export function SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetToJSON(value?: SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(SharedserviceMelcoModelsPreviewToJSON)),
    };
}


